module.exports = __webpack_public_path__ + "img/grafico-em-linha.e68fe5f0.svg";